import React from 'react';
import useFetchData from '../../../../hooks/useFetchData';
import GeneralComponentErrorShield from '../../../general/GeneralComponentErrorShield';
import BenchmarkBreakdownChart from './subComponents/SectorReturnAnalysisChart.component';
import BenchmarkBreakdownTable from './subComponents/SectorReturnAnalysisTable.component';
import {
  activeDateRangeEndSelector,
  activeDateRangeStartSelector,
} from '../../../../redux/pages/selectors';
import { useSelector } from 'react-redux';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import NoDataMessage from '../../../feedback/NoDataMessage.component';

const SubFundVsBenchmark: React.FC<FundInfoComponentProps> = ({ fundId }) => {
  const fromDate = useSelector(activeDateRangeStartSelector);
  const toDate = useSelector(activeDateRangeEndSelector);

  const PerformanceAttributionData = useFetchData({
    url: `/performance_attribution/${fundId}/${fromDate}/${toDate}`,
    keyName: `performance_attribution_${fundId}_${fromDate}_${toDate}`,
    makeFetch:
      fundId !== undefined &&
      fromDate !== null &&
      fromDate !== '' &&
      toDate !== null &&
      toDate !== '',
  });

  // TODO: migrate this config check to the backend. For now the page is only
  // configured when sector_wise_benchmarkvsfund is present.
  const isConfigured = Array.isArray(
    PerformanceAttributionData?.data?.[0]?.sector_wise_benchmarkvsfund,
  );

  return (
    <GeneralComponentErrorShield
      dataObjects={[PerformanceAttributionData]}
      customLoadingMessages={[
        'Loading Performance Attribution Data',
        `${fromDate} to ${toDate}`,
        'Just a few more seconds...',
      ]}
      customErrorMessage="No Data Available."
    >
      {isConfigured ? (
        <>
          <BenchmarkBreakdownChart data={PerformanceAttributionData} />
          <BenchmarkBreakdownTable data={PerformanceAttributionData} />
        </>
      ) : (
        <NoDataMessage message="This page is not configured." />
      )}
    </GeneralComponentErrorShield>
  );
};

export default SubFundVsBenchmark;
